import type { IconData } from '@stacksjs/iconify-core'

export const commentBubble: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M496 496h-16a273.4 273.4 0 0 1-179.025-66.782l-16.827-14.584A291 291 0 0 1 256 416c-63.527 0-123.385-20.431-168.548-57.529C41.375 320.623 16 270.025 16 216S41.375 111.377 87.452 73.529C132.615 36.431 192.473 16 256 16s123.385 20.431 168.548 57.529C470.625 111.377 496 161.975 496 216a171.16 171.16 0 0 1-21.077 82.151a201.5 201.5 0 0 1-47.065 57.537a285.2 285.2 0 0 0 63.455 97l4.687 4.685ZM294.456 381.222l27.477 23.814a241.4 241.4 0 0 0 135 57.86a317.5 317.5 0 0 1-62.617-105.583l-4.395-12.463l9.209-7.068C440.963 305.678 464 262.429 464 216c0-92.636-93.309-168-208-168S48 123.364 48 216s93.309 168 208 168a259 259 0 0 0 31.4-1.913Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default commentBubble
